import { getRoot, types } from 'mobx-state-tree';
import { IRootStore } from 'store/root';

export const NewsModel = types
    .model('NewsOne', {
        Category: types.string,
        Id: types.identifierNumber,
        ImageThumbnail2: types.maybeNull(types.string),
        Title: types.string,
        Summary: types.optional(types.string, '', [null]),
        // UpdateDate: types.string,
        LiveDate: types.string,
        CreateDate: types.optional(types.number, 0),
        ThreadId: types.optional(types.string, ''),
        BoardTitle: types.optional(types.string, ''),
        BoardId: types.optional(types.number, 0),
    })
    .views((self) => ({
        get root(): IRootStore {
            return getRoot<IRootStore>(self);
        },
    }))
    .views((self) => ({
        get LiveDateLoc(): string {
            return new Date(self.LiveDate).toLocaleString(self.root.systemInfo.locale);
        },
    }));